module.exports = __webpack_public_path__ + "img/network-wifi.9715cd7.svg";